import React, { Component } from 'react';
import { Table, } from 'react-bootstrap';
import DBService from '../../service/DBService';

class ATSShowDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            atsList: [],
            limit: this.props.limit,
            symbol: this.props.symbol,
            week: this.props.week
        };
        console.log('ATSShowDetails props', this.props, this.state.symbol, this.state.week);
    }

    componentDidMount() {
        DBService.getAts(this.state.week, this.state.symbol)
            .then(result => {
                console.log('getAts', result);
                if (result !== undefined && result.data !== undefined && result.data.length >0){
                    this.setState({ atsList: result.data });
                }
            })
            .catch((error) => {
                console.log(error);
            });

    }

    renderRow(listValue) {
        if (listValue !== undefined && listValue.issueSymbolIdentifier !== undefined) {
            return (
                <tr key={Math.random()} >
                    <td style={{ textAlign: 'left' }}>{listValue.marketParticipantName}</td>
                    <td style={{ textAlign: 'right' }}>{listValue.totalWeeklyShareQuantity}</td>
                    <td style={{ textAlign: 'right' }}>{listValue.totalWeeklyTradeCount}</td>
                </tr>
            )
        }
    }

    render() {
        let tableRow;
        if (this.state.atsList !== undefined && this.state.atsList.length !== undefined && this.state.atsList.length > 0) {
            tableRow = this.state.atsList.map(this.renderRow.bind(this));            
        } else {
            tableRow = <tr><td></td><td>No Data</td><td></td></tr>
        }
        console.log('atsList', this.state.atsList.length);

        return (
            <Table striped hover bordered size="xs" style={{ fontSize: "10px" }} responsive key={Math.random()}>
                <thead>
                    <tr>
                        <th>ATS Description</th>
                        <th>Shares</th>
                        <th>Trades</th>
                    </tr>
                </thead>
                <tbody>
                    {tableRow}
                </tbody>
            </Table>
        );
    }
}

export default ATSShowDetails;
